import type { IconData } from '@stacksjs/iconify-core'

export const userFaceMale: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#fff\" d=\"M3 24c0 11.598 9.402 21 21 21s21-9.402 21-21S35.598 3 24 3S3 12.402 3 24\"/><path fill=\"#8fbffa\" d=\"M3.094 21.999C13.974 21.95 22.901 13.629 23.906 3C13.026 3.048 4.1 11.37 3.094 21.999m41.812 0C34.026 21.95 25.099 13.629 24.094 3c10.88.048 19.807 8.37 20.812 18.999\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 24c0 11.598 9.402 21 21 21s21-9.402 21-21S35.598 3 24 3S3 12.402 3 24\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M23.906 3c-1.005 10.629-9.931 18.951-20.812 18.999m41.812 0C34.026 21.95 25.099 13.629 24.094 3M16 24v2m16-2v2m-1 8c-3.062 4-10.937 4-14 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userFaceMale
